"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ua;
function getUA() {
    if (ua === undefined) {
        ua = '';
        try {
            if (typeof navigator !== 'undefined') {
                ua =
                    (navigator &&
                        (navigator.userAgent || navigator.swuserAgent)) ||
                        '';
            }
        }
        catch (e) {
            ua = '';
        }
    }
    return ua;
}
exports.default = getUA;
